export const ACCOUNT_MENU_TOGGLE = 'ACCOUNT_MENU_TOGGLE';

const toggleAccountMenu = open => ({
  open,
  type: ACCOUNT_MENU_TOGGLE,
});

export default {
  toggleAccountMenu,
};
